import { get, post } from '@/api/request';

// 公司校验
export const checkCompany = text => get("/check", { text })

// 微信扫码登录
export const loginWithQrcode = code => post(`/login?wx_code=${code}`)

// 用户名密码登录
export const loginWithAccount = params => post("/loginByAccount", params)

// 登出
export const logout = params => get("/logout", params)


// WEBPACK FOOTER //
// ./src/api/common/index.js